export default __webpack_public_path__ + "1111d9f64ad79c2197b88215feaef1a3.svg";